import axios from 'axios';

// Create an axios instance with your new Base URL
const api = axios.create({
  baseURL: 'https://fls-api.ultraviolette.com/cms',
  //baseURL: 'http://localhost:7777',
});

// Add a request interceptor to attach the Token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Dispatch custom event that SessionExpiredPopup listens for
      window.dispatchEvent(new Event("auth:session-expired"));
    }
    return Promise.reject(error);
  }
);

export default api;
